/**
 * Customer Settings V2 — "Pricing" section: device and feature
 * pricing management via the shared `UnifiedPricingManager`.
 *
 * Contains:
 * - PricingSection (default export)
 */

import PaidIcon from '@mui/icons-material/Paid';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import UnifiedPricingManager from '@sophocles/components/UnifiedPricingManager';
import { loadBillingAccountAgreements } from '@sophocles/features/billing/api';
import { selectBillingAccountAgreements } from '@sophocles/features/billing/slice';
import { SettingsSection } from '@sophocles/views/settings/components';

import { accountingOnlyChip } from './chips';

export default function PricingSection({ customer, accountId }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const agreements = useSelector(state => selectBillingAccountAgreements(accountId)(state)) || [];
  React.useEffect(() => {
    if (accountId != null) {
      dispatch(loadBillingAccountAgreements({ account: accountId }));
    }
  }, [dispatch, accountId]);
  const activeAgreement = agreements.find(a => a.is_active) || agreements[0];
  return (
    <SettingsSection
      id="settings-pricing"
      icon={<PaidIcon />}
      title={t('customerSettings.v2.pricing', 'Pricing')}
      description={t('customerSettings.pricingDescription', 'Device and feature pricing management.')}
      chip={accountingOnlyChip(t)}
    >
      <UnifiedPricingManager
        accountId={accountId}
        customerId={customer.get('id', null)}
        isBilledVirtual={Boolean(activeAgreement?.is_billed_virtual)}
        inventoryPolicy={activeAgreement?.inventory_policy || 'exact'}
      />
    </SettingsSection>
  );
}
